module.exports = __webpack_public_path__ + "a129ff8b6aac5546cdb9b3da39a714a7.png";